import React from "react";
import { Grid, TextField } from "@mui/material";

const FortyThreeIForm = ({ settings }) => (
  <Grid container spacing={2} sx={{ p: 2 }}>
    <Grid size={{ xs: 12, md: 6, lg: 3 }}>
      <TextField label="IP Address" value={settings?.ipAddress ?? ""} slotProps={{ input: { readOnly: true } }} fullWidth />
    </Grid>
  </Grid>
);

export default FortyThreeIForm;
